import * as fs from "fs";
import { set_fs } from "xlsx";

set_fs(fs);
